import React from "react";


const Modal = ({ show, onClose, children }) => {
  if (!show) return null; // don’t render if not visible

  const handleOverlayClick = (e) => {
    if (e.target.className === "modal-overlay") {
      onClose(); // close if clicked outside the modal box
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ✖
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;

